export default __webpack_public_path__ + "static/down-arrow-icon-2b972ed489c4cd920f78ed112f970841.svg";